import HelpNavCard from "./components/HelpNavCard";

const HelpCenterNav = () => (
	<nav className="help-center__nav-grid" aria-label="Help center sections">
		<HelpNavCard section="faqs" translationKey="help_center.faqs" />
		<HelpNavCard
			section="training"
			translationKey="help_center.training_materials"
		/>
		<HelpNavCard
			section="publications"
			translationKey="help_center.publications"
		/>
		<HelpNavCard
			section="release-notes"
			translationKey="help_center.release_notes"
		/>
	</nav>
);

export default HelpCenterNav;
